var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlush1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F45E20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,0C11.2,0,0,11.2,0,25s11.2,25,25,25s25-11.2,25-25S38.8,0,25,0z M25,48C12.3,48,2,37.7,2,25S12.3,2,25,2 s23,10.3,23,23S37.7,48,25,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.8,22.4c-2.7,0-5,2.2-5,5c0,1.6,0.8,3.1,2,4c-2.1,2.8-5.3,4.5-8.9,4.5c-3.6,0-6.8-1.7-8.9-4.5 c1.2-0.9,2-2.4,2-4c0-2.7-2.2-5-5-5c-2.7,0-5,2.2-5,5c0,2.7,2.2,5,5,5c0.4,0,0.8-0.1,1.1-0.1c2.4,3.5,6.3,5.6,10.7,5.6 c4.3,0,8.3-2.1,10.7-5.6c0.4,0.1,0.8,0.1,1.1,0.1c2.7,0,5-2.2,5-5C41.8,24.6,39.6,22.4,36.8,22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.7,20.2c0.5,0,1-0.3,1-1c0-1.7,1.4-3,3-3c1.7,0,3,1.4,3,3c0,0.7,0.5,1,1,1c0.5,0,1-0.3,1-1c0-2.7-2.2-5-5-5 c-2.7,0-5,2.2-5,5C27.8,20,28.3,20.2,28.7,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,20.2c0.5,0,1-0.3,1-1c0-1.7,1.4-3,3-3c1.7,0,3,1.4,3,3c0,0.7,0.5,1,1,1s1-0.3,1-1c0-2.7-2.2-5-5-5 c-2.7,0-5,2.2-5,5C12.3,20,12.8,20.2,13.3,20.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlush1);
export default __webpack_public_path__ + "static/media/blush1.7f340b42bd26799b61c8ae7bbfbd03c5.svg";
export { ForwardRef as ReactComponent };